import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-nav-list-item',
    template: `
    <ng-content select="[luiNavListItemIcon]"></ng-content>
    <span class="lui-nav-list-item-label">
      <ng-content></ng-content>
    </span>
  `,
    standalone: false
})
export class NavListItemComponent {
  @HostBinding('class') hostClass = 'lui-nav-list-item';
}
